import React,{useState} from 'react'
import StarRating from './StarRating'
import {CartState} from '../../context/Context'
import {AiOutlineHeart, AiFillHeart} from 'react-icons/ai'
import {useHistory} from 'react-router-dom'


const ProductCard = ({prod,qty}) => {
const [showBtn, setShowBtn] = useState(false);

  const {
    state: { cart,favourite },
    dispatch,
  } = CartState();  
const {rating, price ,name, image } = prod;

const addToCart = () => {
  setShowBtn(true);
  dispatch({ type: 'ADD_TO_CART', payload: prod });
};
  
const increaseQty = (item) => {
  const value = qty + 1;
   dispatch({
     type: "CHANGE_CART_QTY",
     payload: {
       id: item.id,
       qty: value,
     },
   })
 }
 const decreaseQty = (item) => {
 const  value = qty - 1;
 if(value < 1){
   setShowBtn(false)
 }
   dispatch({
     type: "CHANGE_CART_QTY",
     payload: {
       id: item.id,
       qty: value,
     },
   })
 }
const history = useHistory();
const goToProduct = (id) => {
  history.push(`/product/${id}`)
}
  return (
    <div className="relative h-auto w-11/12 lg:mr-4 rounded mx-auto mb-6 md:mb-4 lg:mt-4 md:h-auto md:w-56 lg:h-auto lg:w-60 cursor-pointer overflow-x  trasition duration-700 transform easy-in hover:scale-105 bg-white p-4  font-poppins" >
      <div className="absolute   z-50 top-5 right-5">
        {
          favourite.find(item => item.id === prod.id) ? ( 
            <AiFillHeart className="text-white text-4xl" onClick={() => dispatch({type: 'REMOVE_FROM_FAVOURITE', payload: prod}) } />
          ) : (
            <AiOutlineHeart className="text-white text-4xl " onClick={() => dispatch({type: 'ADD_TO_FAVOURITE', payload: prod})} />
          )
        }
        </div>
      <div className="flex flex-col space-y-1">
        <img src={image} alt={name} onClick={ () => goToProduct(prod.id)}
        className="object-cover filter brightness-75 h-48 md:h-40 lg:h-36 "
        />
        <p className=" text-sm text-black  truncate">
          {name}
          </p>
          <p className="font-bold text-black">
            {price}
          </p>
          <div className="flex align-center">

          <StarRating value={rating} />
          <p className="text-black ml-2" style={{fontSize:'0.7rem'}}>(20)</p>
          </div>
        
            {
              qty ? (
                <div className="flex bg-white space-x-2 justify-between px-2 h-8 ">
                <button className="outline-none border-none bg-tradr-green text-white px-3 py-1 font-bold rounded-sm" onClick={() => decreaseQty(prod)} >-</button>
                <p className="text-black font-bold">{qty}</p>
                <button className="outline-none border-none bg-tradr-green text-white px-3 py-1 font-bold rounded-sm text-xl" onClick={ () => increaseQty(prod)} >+</button>
                {/* end of cart btn */}
            </div>
              ) : (
                <button className="font-bold text-white bg-tradr-green text-sm px-2 py-1 "  onClick={addToCart}>
                Add to Cart
              </button>
              )
            }



















          {/* {
            cart.find((item) => item.id === prod.id) ? (
              <button className="font-bold text-white bg-tradr-green text-sm px-2 py-1 "
              onClick={() => dispatch({ type: 'REMOVE_FROM_CART', payload: prod })}
              >
                Remove from cart
              </button>
            ) : (
              <button className="font-bold text-white bg-tradr-green text-sm px-2 py-1 "  onClick={() => dispatch({ type: 'ADD_TO_CART', payload: prod })}>
                Add to Cart
              </button>
            )

          } */}

       
      </div>
   
    </div>
  )
}

export default ProductCard